import { Component, Input } from '@angular/core';
import { magicPreviewDummyData } from '../../../classes/company';

@Component({
    selector: 'aira-labelled-pills',
    templateUrl: './aira-labelled-pills.component.html',
    styleUrl: './aira-labelled-pills.component.css',
    standalone: false
})
export class AiraLabelledPillsComponent {
  @Input() label = '';
  @Input() data;
  @Input() textPropertyName;
  @Input() onHoverPropertyName;
  @Input() previewOnly: boolean = false;

  pillsToRender: any[] = [];
  leftoverCount: number = 0;

  ngOnInit() {
    if (this.previewOnly) {
      this.data = magicPreviewDummyData.pillsFactors;
      this.textPropertyName = null;
    }

    this.handlePillsData();
  }

  handlePillsData() {
    if (!this.data?.length) return;

    if (this.data.length <= 4) {
      this.pillsToRender = this.data;
      return;
    }

    if (this.data.length > 4) {
      this.leftoverCount = this.data.length - 4;
      this.pillsToRender = this.data.slice(0, 4);
    }
  }

  showAllPills() {
    this.pillsToRender = this.data;
    this.leftoverCount = null;
  }
}
